import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { api } from "../lib/api";

const COLORS = ["#10b981", "#facc15", "#3b82f6", "#f97316", "#ef4444"];

// Shown once to the rep the first time they open a deal Jeff just signed.
export const SignedCelebration = ({ lead, userId, onSeen }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (lead?.bucket === "signed" && lead.signed_uid === userId && lead.signed_seen === false) {
      setShow(true);
      api.post(`/leads/${lead.id}/signed-seen`).then(() => onSeen?.({ ...lead, signed_seen: true })).catch((e) => console.warn("signed-seen", e));
    } else setShow(false);
  }, [lead?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!show) return null;
  return (
    <div className="relative mt-4 overflow-hidden rounded-2xl bg-emerald-600 text-white p-5 celebrate-pop" data-testid="signed-celebration">
      {Array.from({ length: 18 }).map((_, i) => (
        <span key={i} className="confetti" style={{ left: `${(i * 37) % 100}%`, background: COLORS[i % COLORS.length], animationDelay: `${(i % 6) * 0.12}s` }} />
      ))}
      <div className="relative flex items-center gap-3">
        <PartyPopper className="h-8 w-8 shrink-0" />
        <div>
          <p className="font-display text-xl font-extrabold">Deal Signed!</p>
          <p className="text-sm text-emerald-50">Congratulations, {lead.name} is a done deal. Great work!</p>
        </div>
      </div>
      <button onClick={() => setShow(false)} className="relative mt-3 text-xs font-semibold underline text-emerald-50 hover:text-white" data-testid="signed-celebration-close">Close</button>
    </div>
  );
};
